const Resources = {

    table_headers: [
        {
            text:   "Report name",
            align:  "start",
            value:  "name",
            type:   "link",
        },
        {
            text:   "Created On",
            value:  "created_at",
            type:   'date',
        },
        {
            text:   "Last modified by",
            value:  "last_modified_by"
        },
        {
            text:   "Last modified date",
            value:  "updated_at",
            type:   "date",
        },
        {
            text:   "Report last run day",
            value:  "last_run_at",
            type:   "date",
        },
    ],

    form_table_headers: [
        {
            text:   "Name",
            align:  "start",
            value:  "name",
            // type:   "",
        },
    ],

    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "",
        },
    ],

    table_headers_test: [
        {
            text:   "Report Number",
            align:  "start",
            value:  "ReportNumber"
        },
        {
            text:   "Description",
            value:  "rp_descr"
        },
        {
            text:   "File",
            value:  "rp_file"
        },
        {
            text:   "Name",
            value:  "rp_name"
        },
    ],

    system_list: [
        {
            name: 'Recent & public reports',
            identify: 'all',
        },
        // {
        //     name: 'Facility',
        //     identify: 'facility',
        // },
        {
            name: 'Buildings',
            identify: 'buildings',
        },
        {
            name: 'Associates',
            identify: 'associates',
        },
        {
            name: 'Assignments',
            identify: 'assignments',
        },
        {
            name: 'Budgeting',
            identify: 'budgeting',
        },
        {
            name: 'Census',
            identify: 'census',
        },
        {
            name: 'Days Off',
            identify: 'daysoff',
        },
        {
            name: 'QC',
            identify: 'qc',
        },
        // {
        //     name: 'Utilities',
        //     identify: 'utilities',
        // },
        {
            name: 'Options',
            identify: 'options',
        },
    ],

    form_system_list: [
        {
            name: 'All',
            identify: 'all',
            views: [],
        },
        // {
        //     name: 'Facility',
        //     identify: 'facility',
        //     views: [
        //         {
        //             checked: false,
        //             name: 'Facility',
        //             model: 'facilities',
        //         },
        //     ],
        // },
        {
            name: 'Buildings',
            identify: 'buildings',
            views: [
                {
                    checked: false,
                    name: 'Buildings',
                    model: 'buildings',
                },
                {
                    checked: false,
                    name: 'Levels',
                    model: 'levels',
                },
                {
                    checked: false,
                    name: 'Areas',
                    model: 'areas',
                },
                {
                    checked: false,
                    name: 'Rooms',
                    model: 'rooms',
                },
                {
                    checked: false,
                    name: 'Room Tasks',
                    model: 'room_tasks',
                },
                {
                    checked: false,
                    name: 'Cost center',
                    model: 'cost_centers',
                },
                {
                    checked: false,
                    name: 'Cost Center Departments',
                    model: 'cost_center_departments',
                },
                {
                    checked: false,
                    name: 'Personnel',
                    model: 'cost_center_personnel',
                },
                {
                    checked: false,
                    name: 'Room Types',
                    model: 'room_types',
                },
            ],
        },
        {
            name: 'Associates',
            identify: 'associates',
            views: [
                {
                    checked: false,
                    name: 'Associates',
                    model: 'associates',
                },
                {
                    checked: false,
                    name: 'Positions',
                    model: 'positions',
                },
                {
                    checked: false,
                    name: 'Contact Types',
                    model: 'contract_types',
                },
            ],
        },
        {
            name: 'Assignments',
            identify: 'assignments',
            views: [
                {
                    checked: false,
                    name: 'Daily Assignments',
                    model: 'daily_assignments',
                },
                {
                    checked: false,
                    name: 'Shifts',
                    model: 'shifts',
                },
                {
                    checked: false,
                    name: 'Tasks',
                    model: 'tasks',
                },
                {
                    checked: false,
                    name: 'Projects',
                    model: 'projects',
                },
                {
                    checked: false,
                    name: 'Service Requests',
                    model: 'service_requests',
                },
            ],
        },
        {
            name: 'Budgeting',
            identify: 'budgeting',
            views: [
                {
                    checked: false,
                    name: 'Staffing Scenarios',
                    model: 'staffing_scenarios',
                },
                // {
                //     checked: false,
                //     name: 'Forecaster',
                //     model: 'forecasters',
                // },
            ],
        },
        {
            name: 'Census',
            identify: 'census',
            views: [
                {
                    checked: false,
                    name: 'Beds',
                    model: 'beds',
                },
                {
                    checked: false,
                    name: 'Log Productivity',
                    model: 'log_productivities',
                },
            ],
        },
        {
            name: 'Days Off',
            identify: 'daysoff',
            views: [
                {
                    checked: false,
                    name: 'Rotation Templates',
                    model: 'rotation_templates',
                },
            ],
        },
        {
            name: 'QC',
            identify: 'qc',
            views: [
                {
                    checked: false,
                    name: 'Inspection templates',
                    model: 'inspection_templates',
                },
                {
                    checked: false,
                    name: 'Instant Inspections',
                    model: 'instant_inspections',
                },
                {
                    checked: false,
                    name: 'Template Inspections',
                    model: 'template_inspections',
                },
                {
                    checked: false,
                    name: 'Inspection Items',
                    model: 'inspection_items',
                },
                {
                    checked: false,
                    name: 'Surveys',
                    model: 'surveys',
                },
            ],
        },
        // {
        //     name: 'Utilities',
        //     identify: 'utilities',
        //     views: [
        //         {
        //             checked: false,
        //             name: 'Walking number update',
        //             model: '',
        //         },
        //         {
        //             checked: false,
        //             name: 'Project code mass delete',
        //             model: '',
        //         },
        //         {
        //             checked: false,
        //             name: 'Project code mass add',
        //             model: '',
        //         },
        //     ],
        // },
        {
            name: 'Options',
            identify: 'options',
            views: [
                {
                    checked: false,
                    name: "Step Codes",
                    model: 'step_codes',
                },
                {
                    checked: false,
                    name: 'Floor Types',
                    model: 'floor_types',
                },
                {
                    checked: false,
                    name: 'V. Beds Adjustment',
                    model: 'vacant_beds_adjustment',
                },
                {
                    checked: false,
                    name: 'Time Off',
                    model: 'time_off',
                }
            ],
        },
    ],

    helps: [
        {
            label: '¿How to create a Custom Report?', 
            instruction: `https://scribehow.com/embed/Creating_a_Custom_Report__7ylEIxnUSxKDAFXjnB7SHA?as=scrollable`
        },
    ]

}

export default Resources;